import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #1f2937;
  color: white;
  padding: 3rem 0 1rem;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  h4 {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #f9fafb;
  }

  p {
    color: #d1d5db;
    line-height: 1.6;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 0.5rem;

      a {
        color: #d1d5db;
        text-decoration: none;
        transition: color 0.3s ease;

        &:hover {
          color: #3b82f6;
        }
      }
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    justify-content: center;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #374151;
    color: white;
    border-radius: 8px;
    text-decoration: none;
    transition: background 0.3s ease;

    &:hover {
      background: #1e40af;
    }
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid #374151;
  color: #9ca3af;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <Container>
        <FooterContent>
          <FooterSection>
            <h4>Tech Week Grand Rapids</h4>
            <p>Building West Michigan's tech ecosystem through collaboration and innovation.</p>
          </FooterSection>
          
          <FooterSection>
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#highlights">2025 Highlights</a></li>
              <li><a href="#recommendations">2026 Recommendations</a></li>
              <li><a href="#timeline">Timeline</a></li>
            </ul>
          </FooterSection>
          
          <FooterSection>
            <h4>Connect</h4>
            <SocialLinks>
              <a href="#" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
            </SocialLinks>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; 2025 Tech Week Grand Rapids Engagement Committee. All rights reserved.</p>
        </FooterBottom>
      </Container>
    </FooterContainer>
  );
};

export default Footer;